module.exports = __webpack_public_path__ + "img/iOS_miaoshu.af08649c.png";